import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import actions from "../Store/actions";
import { history } from "../common/lib";
import config from "../config";

/**
 * SignIn Component - executed when Azure Sign In after successful
 * authentications redirect to this component. At the end of the url
 * Azure appends #id_token
 */
const SignIn = () => {
    const dispatch = useDispatch();
    const { hash } = useLocation();

    useEffect(async () => {
        const idToken = hash.split("#id_token=")[1];

        if (idToken) {
            await dispatch(actions.auth.create.getRequest({ idToken }));
            history.replace(`/${config.paths.auth}`);
        } else history.replace(`/${config.paths.login}`);
    }, []);

    return null;
};

export default SignIn;
